import React from 'react';

// Clever's "C" brandmark. Inherits `currentColor`; size/alignment via `className`
export const CleverMark = ({
  className = 'h-[1em] w-[1em] align-[-0.125em]'
}: {className?: string} = {}) => (
  <svg aria-hidden='true' className={className} fill='none' viewBox='0 0 23 25'>
    <path
      clipRule='evenodd'
      d='M12.5349 24.3672C5.34217 24.3672 0 19.0156 0 12.251V12.1834C0 5.48577 5.23755 0 12.7445 0C17.3535 0 20.1118 1.48093 22.3812 3.63479L18.9595 7.43813C17.074 5.78901 15.1537 4.77934 12.7096 4.77934C8.58939 4.77934 5.62146 8.07757 5.62146 12.1161V12.1834C5.62146 16.2221 8.51953 19.5879 12.7096 19.5879C15.5029 19.5879 17.2137 18.511 19.1342 16.8283L22.5559 20.16C20.0419 22.7514 17.2487 24.3672 12.5349 24.3672Z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>
);
